export default __webpack_public_path__ + "static/media/output-svgrepo-com.17654513.svg";